// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"ca85ef56","116":"15fe9473","242":"f660ce2b","267":"34573de7","625":"dbd79871","684":"62308e56","762":"004bf7d8"}[chunkId] + ".chunk.js";
};